import classNames from 'classnames';
import { createPortal } from 'react-dom';

import { Preloader } from '~components/Preloader/Preloader';
import { NextUtils } from '~helpers/NextUtils';

import styles from './PreloaderOverlay.module.scss';
import { PreloaderOverlayProps } from './PreloaderOverlay.types';

export function PreloaderOverlay({ active }: PreloaderOverlayProps) {
  if (NextUtils.isServer() || !active) {
    return null;
  }

  return createPortal(
    <div
      className={classNames(styles.preloaderContainer, {
        [styles.active]: active,
      })}
    >
      <Preloader active={active} />
    </div>,
    document.body,
  );
}
